import { memo, useCallback, useState } from 'react';

import MapViewOutlined from '@icons/MapViewOutlined';
import NavbarButton from '../../Navbar/NavbarButton';
import ShareButtonModals from './ShareButtonModals';

const ShareButton = () => {
  const [modalOpen, setModalOpen] = useState(false);
  const onShare = useCallback(() => {
    setModalOpen(true);
  }, []);
  const onClose = useCallback(() => {
    setModalOpen(false);
  }, []);

  return (
    <>
      {modalOpen && <ShareButtonModals onClose={onClose} />}
      <NavbarButton
        viewConfig={{
          displayName: 'Views',
          inactiveIcon: MapViewOutlined,
          activeIcon: MapViewOutlined,
          group: 'main',
          enabled: true
        }}
        onClick={onShare}
      />
    </>
  );
};

export default memo(ShareButton);
